/* global axios */
import ApiClient from './ApiClient';

class ZernioSocialInboxesAPI extends ApiClient {
  constructor() {
    super('zernio_social_inboxes', { accountScoped: true });
  }

  availableAccounts(platform = 'tiktok') {
    return axios.get(`${this.url}/available_accounts`, {
      params: { platform },
    });
  }
}

export default new ZernioSocialInboxesAPI();
